export const SET_ASSESSMENT_RESULTS = 'assessment/SET_ASSESSMENT_RESULTS';
export const SET_ASSESSMENT_RESULTS_SUCCESS = 'assessment/SET_ASSESSMENT_RESULTS_SUCCESS';
export const SET_ASSESSMENT_RESULTS_ERROR = 'assessment/SET_ASSESSMENT_RESULTS_ERROR';

// Phase 4 of the assessment refactor — fetch an Assessment template
// by its _id. Used by both the trainer's client tab and the client's
// own /dashboard/profile to render their assigned template instead
// of a hardcoded set. Cached per-id in state.assessment.templatesById
// so the same template isn't refetched on every render.
export const GET_ASSESSMENT_BY_ID = 'assessment/GET_ASSESSMENT_BY_ID';
export const GET_ASSESSMENT_BY_ID_SUCCESS =
  'assessment/GET_ASSESSMENT_BY_ID_SUCCESS';
export const GET_ASSESSMENT_BY_ID_ERROR =
  'assessment/GET_ASSESSMENT_BY_ID_ERROR';